// extracted by mini-css-extract-plugin
export default {"cardBoxContainer":"Tips_cardBoxContainer__rCJG2","cardBoxContainerExtended":"Tips_cardBoxContainerExtended__lC9dY"};